/** Markers the legal-texts API replaces with academy fiscal data. */
export const LEGAL_FISCAL_MARKERS = [
  { token: "{{razonSocial}}", labelKey: "legalTexts.markerRazonSocial" },
  { token: "{{nif}}", labelKey: "legalTexts.markerNif" },
  { token: "{{domicilio}}", labelKey: "legalTexts.markerDomicilio" },
  { token: "{{email}}", labelKey: "legalTexts.markerEmail" },
  { token: "{{telefono}}", labelKey: "legalTexts.markerTelefono" },
];
